// Update to use the secure API endpoint for profile images
export const getImageUrl = (path) => {
    if (!path) return null;
    if (path.startsWith('http')) return path; // Already absolute

    // Get base URL from env or fallback
    const apiBase = process.env.REACT_APP_API_BASE_URL || 'https://api.intuitlms.online/api';

    // NEW: Rewriting logic
    // If the path is a profile picture (starts with /uploads/profiles), 
    // rewrite it to use the secure /api/images endpoint to bypass Nginx static blocks
    if (path.includes('/profiles/') || path.includes('/banners/')) {
        // The path usually looks like /uploads/profiles/filename.jpg
        // We want to transform it to /api/images/profiles/filename.jpg
        // Or if the backend is mounted at /api/images, checking the index.js logic...
        // Backend mount: app.use('/api/images', imageRoutes);
        // imageRoutes: router.get('/profiles/:filename') -> matches /api/images/profiles/:filename

        // Extract filename if needed, or just replace the prefix
        const newPath = path
            .replace('/uploads/profiles', '/api/images/profiles')
            .replace('/uploads/banners', '/api/images/banners');

        // When using /api/images, we should use the FULL apiBase (with /api)
        // apiBase is https://api.intuitlms.online/api
        // So we want https://api.intuitlms.online/api/images/profiles/filename.jpg

        // Ensure path starts with slash
        const cleanPath = newPath.startsWith('/') ? newPath : `/${newPath}`;

        // Note: apiBase already has /api at the end usually. 
        // And newPath starts with /api/images... so we'd get /api/api/images...
        // We need to attach to ROOT host, or just standardise.

        // Let's use the host logic again but cleaner:
        // host = https://api.intuitlms.online
        const host = apiBase.replace(/\/api\/?$/, '');

        return `${host}${cleanPath}`;
    }

    // fallback for other uploads (legacy static serving)
    const host = apiBase.replace(/\/api\/?$/, '');
    const cleanPath = path.startsWith('/') ? path : `/${path}`;

    return `${host}${cleanPath}`;
};
